<fas-service-dynamic-table
  [columns]="columns"
  [dataMode]="'server'"
  [dataService]="fetchOskSubscriptionHistory"
  [columnTemplates]="{
    studentNameTemplate: studentNameTemplateRef,
    planNameTemplate:planNameTemplateRef
  }"
>
<ng-template #planNameTemplateRef let-row>
  <div class="plan-tag py-1 px-2 text-sm border-round-sm" 
  [style.backgroundColor]="row.bgColor"
  [style.color]="row.fgColor">
  {{ row.planName }}
  </div>
</ng-template>

  <ng-template #studentNameTemplateRef let-row>
    <p class="student-cell">
      {{ row.studentName }}
      <span *ngIf="row.studentEmail">({{ row.studentEmail }})</span>
    </p>
  </ng-template>
</fas-service-dynamic-table>
